import React, { useEffect } from 'react';
import { func, oneOf } from 'prop-types';
import useStyles from 'hooks/useStyles';
import { useTranslation } from 'react-i18next';

import BaseModal from 'components/BaseModal';

import { MODAL_MODE } from '../../constants';
import Form from '../Form';
import ThanksInfo from '../ThanksInfo';

import styles from './Modal.scss';

const Modal = ({ mode, onClose, onSubmit }) => {
  useStyles(styles);
  const { t } = useTranslation(['rating']);

  const MODAL = {
    COMPONENT: {
      [MODAL_MODE.FROM]: <Form onClose={onClose} onSubmit={onSubmit} />,
      [MODAL_MODE.THANKS_INFO]: <ThanksInfo />,
    },
    SHOW_CLOSE_BUTTON: {
      [MODAL_MODE.FROM]: true,
      [MODAL_MODE.THANKS_INFO]: false,
    },
  };

  useEffect(() => {
    const handleEscKeyDown = event => {
      // key code 27 is esc
      if (event.keyCode === 27) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscKeyDown, false);
    return () =>
      document.removeEventListener('keydown', handleEscKeyDown, false);
  }, [onClose]);

  return (
    <BaseModal
      classNameMap={{
        content: styles.baseModalContent,
      }}
    >
      <div className={styles.root}>{MODAL.COMPONENT[mode]}</div>
      {MODAL.SHOW_CLOSE_BUTTON[mode] && (
        <span className={styles.closeButton} onClick={onClose}>
          {t('common.close')}
        </span>
      )}
    </BaseModal>
  );
};

Modal.propTypes = {
  mode: oneOf(Object.values(MODAL_MODE)).isRequired,
  onClose: func.isRequired,
  onSubmit: func.isRequired,
};

Modal.defaultProps = {};

export default Modal;
